import { FC } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FieldErrors } from 'old-rhf';

import { Regular } from '@zazume/zzm-base';

const ErrorBase = styled.div(
  ({ theme }) => css`
    margin: ${theme.spacing.s2} ${theme.spacing.s0};
  `
);

interface ErrorProps {
  inputError?: FieldErrors;
}

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const Error: FC<ErrorProps> = ({ inputError }) => {
  const message = inputError?.message;
  if (!message) {
    return null;
  }

  return (
    <ErrorBase>
      <Regular variant="XS" color="Red">
        {message}
      </Regular>
    </ErrorBase>
  );
};
